var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{staticClass:"main-appbar",attrs:{"flat":"","color":"transparent"}},[_c('app-bar-nav-icon'),_c('v-toolbar-title',{staticClass:"headline font-weight-bold"},[_vm._v("Notification")])],1),_c('notification-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }